import React, { Fragment, memo } from 'react'

import { Typo } from 'components/_old/Typo/Typo'

import { Paper } from 'components/atoms/Paper'
import { Typography } from 'components/atoms/Typography'

const Declaration = memo(
  (): React.ReactElement => (
    <Fragment>
      <Typography size={24} weight="semibold" lineHeight="small">
        <Typo>Declaration</Typo>
      </Typography>
      <Paper top={32}>
        <Typography size={14}>
          <Typo>
            <p>
              You are aware that Quai Investment Services Limited is being asked to transfer benefits from your existing
              scheme to the InvestEngine Personal Pension.
            </p>
            <p>Please read the disclaimer below carefully.</p>
            <ul>
              <li>
                I have neither sought nor been given any pension transfer advice or information from Quai Investment
                Services Limited or any of its employees on the subject of pension transfers.
              </li>
              <li>
                I have compared the benefits of the InvestEngine Personal Pension with those of the pension that I am
                transferring.
              </li>
              <li>
                I can confirm that I am aware that there may be some benefits available within my existing scheme that
                will not be available via the InvestEngine Personal Pension.
              </li>
              <li>
                I understand that if I have taken out protection then paying a contribution or making a transfer to the
                InvestEngine Personal Pension could negate this protection.
              </li>
              <li>
                I understand that the InvestEngine Personal Pension does not comply with the "stakeholder" criteria
                which impose certain conditions such as limiting charges to a maximum of 1.5% per annum for the first
                ten years and 1.0% per annum thereafter.
              </li>
            </ul>
          </Typo>
        </Typography>
      </Paper>
    </Fragment>
  ),
)
Declaration.displayName = 'Declaration'

export { Declaration }
